import { render, staticRenderFns } from "./BoardTitle.vue?vue&type=template&id=b6708bca&scoped=true&lang=pug"
import script from "./BoardTitle.vue?vue&type=script&lang=js"
export * from "./BoardTitle.vue?vue&type=script&lang=js"
import style0 from "./BoardTitle.vue?vue&type=style&index=0&id=b6708bca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.18_cache-loader@4.1.0_webpack@4.47.0_supports-_a02809e54f1429825a019cd6b08a4fe2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6708bca",
  null
  
)

export default component.exports